export enum SignupSteps {
  WELCOME = 'WELCOME!',
  SIGN_UP = 'SIGN UP',
  CHOOSE_A_PLAN = 'CHOOSE A PLAN',
  PAYMENT_DETAILS = 'PAYMENT DETAILS'
}
